import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { PlayerSeasonStatsDTO, Season } from '../../../../../../.clients/api-client';

/**
 * Componente "Dumb" (Vista) que muestra:
 * 1. Un selector de Temporadas.
 * 2. Un dashboard con las estadísticas de la temporada seleccionada.
 */
@Component({
  selector: 'app-player-stats-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressBarModule,
    MatIconModule
  ],
  templateUrl: './player-stats-dashboard.component.html',
  styleUrls: ['./player-stats-dashboard.component.scss']
})
export class PlayerStatsDashboardComponent {

  /**
   * Lista de temporadas disponibles para el jugador (para el dropdown).
   */
  @Input({ required: true }) seasons!: Season[] | null;

  /**
   * Estadísticas agregadas de la temporada seleccionada.
   */
  @Input({ required: true }) stats!: PlayerSeasonStatsDTO | null;

  /**
   * Indica si las estadísticas (esta sección) se están cargando.
   */
  @Input({ required: true }) isLoadingStats!: boolean | null;

  /**
   * Evento emitido cuando el usuario cambia la temporada en el <mat-select>.
   */
  @Output() seasonChanged = new EventEmitter<number>();

  /**
   * Manejador del evento (selectionChange) del <mat-select>.
   * @param event El evento de Angular Material.
   */
  onSeasonChange(event: MatSelectChange): void {
    const seasonId = event.value as number;
    if (seasonId) {
      this.seasonChanged.emit(seasonId);
    }
  }
}
